import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { zendeskData } from '../mockData/zendesk-data';

export const ZendeskApi = [rest.get(`${API_ROOT}zendesk/sso`, (req, res, ctx) => res(ctx.json(zendeskData)))];
export const ZendeskReportApi = [rest.post(`${API_ROOT}zendesk/`, (req, res, ctx) => res(ctx.json({ success: true })))];
